import { Component, OnInit, AfterViewInit, OnChanges, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { Builder } from 'path-shared/models/builder';
import { SeguretatUsuarisFilter } from '../../models/seguretat-usuaris-filter';
import { SeguretatUsuaris } from '../../models/seguretat-usuaris.model';
import { SeguretatUsuarisService } from '../../services/seguretat-usuaris.service';
import { SeguretatUsuarisFilterService } from '../../services/seguretat-usuaris-filter.service';

@Component({
  selector: 'app-seguretat-usuaris-table',
  templateUrl: './seguretat-usuaris-table.component.html',
  styleUrls: ['./seguretat-usuaris-table.component.scss']
})
export class SeguretatUsuarisTableComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  data: SeguretatUsuaris[];
  dataSource: CustomDataSource<SeguretatUsuaris, SeguretatUsuarisFilter>;
  filter: SeguretatUsuarisFilter = new SeguretatUsuarisFilter('CodUser', 'asc');
  displayedItems = [];
  highlightedRows = [];

  @Input() selectButton: boolean;
  @Input() updatedFilterData: SeguretatUsuarisFilter;
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

displayedColumns = ['codiUser', 'nomUsuari', 'descripcio', 'email', 'tipus', 'actiu', 'data_inici', 'data_fi',
                    'ultima_conexio', 'zonaBlava', 'policia', 'convivencia', 'institucionDesc'];

  constructor(
    private seguretatUsuarisService: SeguretatUsuarisService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<SeguretatUsuaris, SeguretatUsuarisFilter>(this.paginator, new SeguretatUsuarisFilterService(), 'urlGetSeguretatUsuaris', 'urlGetSeguretatUsuarisCount');
    this.dataSource.subject.subscribe((data) => {
      data.forEach(item => {
        this.displayedItems[item.secureId] = {
          id: item.secureId
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        if (!this.selectButton) { this.filterService.saveFilter('seguretat-usuaris-filter', this.filter); }
      }
    });

    if (!this.selectButton) { this.filterService.loadFilter('seguretat-usuaris-filter', this.filter); }
    this.filter.paginator.init(this.sort, this.paginator);
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);
  }

  onRowClicked(row) {
    this.itemClicked.next(row.secureId);
  }

  generateExcel(): void {
    let filter = this.filter;
    if (this.updatedFilterData != null) {
      filter = this.updatedFilterData;
    }
    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData (this.seguretatUsuarisService, filter, this.i18n('SeguretatUsuaris'), this.sort.direction, this.sort.active)
    });
  }

}
